import type { LucideIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: { label: string; href?: string; onClick?: () => void }
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border/60 px-6 py-16 text-center">
      <div className="mb-4 rounded-xl bg-primary/5 p-4">
        <Icon className="h-8 w-8 text-primary/30" />
      </div>
      <h3 className="mb-1 text-sm font-semibold text-foreground/70">{title}</h3>
      <p className="mb-5 max-w-[280px] text-xs text-muted-foreground">{description}</p>
      {action && (
        action.href ? (
          <Button size="sm" asChild><a href={action.href}>{action.label}</a></Button>
        ) : (
          <Button size="sm" onClick={action.onClick}>{action.label}</Button>
        )
      )}
    </div>
  )
}
